import { toHandicap } from '../../../../../../../contrib/Utils/toHandicap';

export const getFormattedHandicapValue = (handicapValue: string | number | undefined) => {
  const handicapLastChar = String(handicapValue).slice(-1);
  const handicapWithoutLastChar = String(handicapValue).slice(0, -1);

  return handicapValue
    ? handicapLastChar === '.'
      ? `${toHandicap(handicapValue)}.`
      : handicapLastChar === '-'
      ? handicapWithoutLastChar
      : toHandicap(handicapValue)
    : '';
};
